import React from "react";
import { NavLink } from "react-router-dom";

const AdminMenu = () => {
  return (
    <>
      <div className="text-center">
        <div className="list-group">
          <h4> Admin Panel </h4>
          <NavLink
            to="/dashboard/admin/create-category"
            className="list-group-item list-group-item-action btn  mb-1 "
          >
            Categorias
          </NavLink>
          <NavLink
            to="/dashboard/admin/create-provincia"
            className="list-group-item list-group-item-action btn mb-1"
          >
            Provincias
          </NavLink>

          <NavLink
            to="/dashboard/admin/products"
            className="list-group-item list-group-item-action btn  mb-1"
          >
            Products
          </NavLink>
          <NavLink
            to="/dashboard/admin/remesas"
            className="list-group-item list-group-item-action btn  mb-1"
          >
            Remesas
          </NavLink>
          <NavLink
            to="/dashboard/admin/pedidos"
            className="list-group-item list-group-item-action btn  mb-1"
          >
            Pedidos
          </NavLink>
          <NavLink
            to="/dashboard/admin/users"
            className="list-group-item list-group-item-action btn  mb-1 "
          >
            Users
          </NavLink>
        </div>
      </div>
    </>
  );
};

export default AdminMenu;
